import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20rem;
`;

export const Label = styled.label`
  font-weight: 300;
`;
